import { DadosParcela } from "app/types/IncluirEditarParcela"
import { Parametro } from "app/types/Parametro"
import { Permissao } from "app/types/Permissao"
import { obterPermissao } from "app/use-cases/obterPermissao"
import { obterParametros } from "app/use-cases/parametro/obterParametros"
import globalMU from "globalMU"
import React, { memo, useCallback, useEffect, useRef, useState } from "react"
import { Abas } from "../abas/Abas"
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container"
import { FormaDePagamentoContainer } from "./FormaDePagamentoContainer"
import { IncluirEditarParcelaContainer } from "./incluir-editar-parcela/IncluirEditarParcelaContainer"
import { PlanoDePagamentoContainer } from "./PlanoDePagamentoContainer"
import * as R from 'ramda'

type NomesAbas = "Forma de Pagamento" | "Plano de Pagamento"
type Passo = "Forma de Pagamento" | "Incluir Parcela" | "Editar Parcela"

export type TelaFormaDePagamentoContainerProps = {
    somenteLeitura: boolean,
    abaSelecionada?:"Forma de Pagamento" | "Plano de Pagamento",
    mostrarDadosDeContratoPorPadrao?:boolean
}

export const TelaFormaDePagamentoContainer = memo((props: TelaFormaDePagamentoContainerProps) => {
    const isMounted = useRef<boolean>(true)
    useEffect(() => () => { isMounted.current = false }, [])
    const [abaSelecionada, setAbaSelecionada] = useState<NomesAbas>(props.abaSelecionada ?? "Forma de Pagamento")
    const [permissoes, setPermissoes] = useState<Permissao[]>([])
    const [parametros, setParametros] = useState<Parametro[]>([])
    const [abas, setAbas] = useState<{nome:string}[]>([])
    const [executarAcaoLimparPlanoDePagamento, setExecutarAcaoLimparPlanoDePagamento] = useState(false)
    const [executarAcaoLimparFormaDePagamento, setExecutarAcaoLimparFormaDePagamento] = useState(false)
    const [exibirEditarParcela, setExibirEditarParcela] = useState(false)
    const [parcelaSendoEditada, setParcelaSendoEditada] = useState<DadosParcela>(null)
    const [passos, setPassos] = useState<Passo[]>(["Forma de Pagamento"])
    

    const valorParametro = (nome:string) => parametros.find(p => p.Nome == nome)?.Valor

    const exibirAbaPlanoDePagamento = () => {
        return globalMU.possuiPermissao(permissoes, "ORCAMENTO_PLANO_PAGAMENTO") && valorParametro("EMPRESA_UTILIZA_PLANO_DE_PAGAMENTO") == "S"
    }

    const atualizarPermissoes = async () => {
        const permissao = await obterPermissao({funcionalidade: "ORCAMENTO_PLANO_PAGAMENTO"})
        if (isMounted.current) {
            setPermissoes([
                {
                    Funcionalidade: "ORCAMENTO_PLANO_PAGAMENTO",
                    Permitido: permissao
                }
            ])
        }
    }

    const atualizarParametros = async () => {
        const params = await obterParametros({
            nomes: [
                "EMPRESA_UTILIZA_PLANO_DE_PAGAMENTO",
                "VENDA_RECEBER_ENTREGA"
            ]
        })
        if (isMounted.current) {
            setParametros(params)
        }
    }

    const atualizarAbas = () => {
        if (isMounted.current) {
            setAbas([
                {
                    nome: "Forma de Pagamento"
                },
                {
                    nome: exibirAbaPlanoDePagamento() ? "Plano de Pagamento" : undefined
                }
            ].filter(aba => aba.nome != undefined))
        }
    }

    const limpar = useCallback(() => {
        switch (abaSelecionada) {
            case "Plano de Pagamento":
                setExecutarAcaoLimparPlanoDePagamento(true)
                setTimeout(() => setExecutarAcaoLimparPlanoDePagamento(false), 1000)
                break;
            case "Forma de Pagamento":
                setExecutarAcaoLimparFormaDePagamento(true)
                setTimeout(() => setExecutarAcaoLimparFormaDePagamento(false), 1000)
                break;
        }
    }, [abaSelecionada])

    const onParcelaAtualizada = useCallback(async () => {
        if (isMounted.current) {
            setExibirEditarParcela(false)
            setParcelaSendoEditada(null)
            setPassos(["Forma de Pagamento"])
        }
    }, [])

    const onEditarParcela = useCallback(async (parcela: DadosParcela) => {
        setParcelaSendoEditada(parcela)
        setExibirEditarParcela(true)
        setPassos(["Forma de Pagamento", "Editar Parcela"])
    }, [])

    const onIncluirParcela = useCallback(async () => {
        setExibirEditarParcela(true)
        setPassos(["Forma de Pagamento", "Incluir Parcela"])
    }, [])

    const cancelarEdicaoInsercaoParcela = useCallback(() => {
        if (isMounted.current) {
            setParcelaSendoEditada(null)
            setPassos(["Forma de Pagamento"])
            setExibirEditarParcela(false)
        }
    }, [])


    useEffect(() => {
        const fetchData = async () => {
            await Promise.all([
                atualizarParametros(),
                atualizarPermissoes(),
            ])
        }

        fetchData()
    },[])

    useEffect(() => {
        atualizarAbas()
    },[permissoes, parametros])

    return (
<>
{permissoes !=null && permissoes.length > 0 
        && parametros && parametros.length > 0 
        && abas && abas.length > 0 
        && passos && passos.length > 0 
    ? 
        <>
        <Breadcrumb2Container
            passos={passos}
            id="TelaFormaDePagamentoBreadcrumb"
            exibirBotaoLimpar={!exibirEditarParcela}
            exibirBotaoVoltar={exibirEditarParcela}
            onBotaoVoltarClicado={cancelarEdicaoInsercaoParcela}
            onPassoSelecionado={passo => {
                if (passo == "Forma de Pagamento" && exibirEditarParcela) {
                    setExibirEditarParcela(false)
                    setPassos(["Forma de Pagamento"])
                }
            }}
            onBotaoLimparClicado={limpar}/>

        {!exibirEditarParcela && <Abas
            abas={abas}
            id="TelaFormaDePagamentoAbas"
            nomeAbaSelecionada={abaSelecionada}
            onAbaSelecionada={nome => setAbaSelecionada(nome as NomesAbas)}/>}

        {abaSelecionada == "Forma de Pagamento" && !exibirEditarParcela 
        &&  <FormaDePagamentoContainer
            somenteLeitura={props.somenteLeitura}
            executarAcaoLimpar={executarAcaoLimparFormaDePagamento}
            onEditarParcela={onEditarParcela}
            onIncluirParcela={onIncluirParcela}
            />}

        {abaSelecionada == "Plano de Pagamento" && !exibirEditarParcela 
        && <PlanoDePagamentoContainer
            somenteLeitura={props.somenteLeitura}
            mostrarDadosDeContratoPorPadrao={props.mostrarDadosDeContratoPorPadrao}
            executarAcaoLimpar={executarAcaoLimparPlanoDePagamento}/>}

        {exibirEditarParcela && <IncluirEditarParcelaContainer
                somenteLeitura={props.somenteLeitura}
                editandoPlanoPagamento={false}
                indiceParcela={parcelaSendoEditada?.Index}
                parcela={parcelaSendoEditada}
                onParcelaAtualizada={onParcelaAtualizada}
                />}
    </>
    : <><span>Carregando... Aguarde!</span></>
}
    </>
    )
})